import React from "react"
import { Heading, HeadingProps } from "@chakra-ui/react"

import useLearnPage from "@hooks/useLearnPage"

const LearnPageTitle = (props: HeadingProps) => {
  const { item } = useLearnPage()

  return (
    <Heading
      as="h4"
      size="h4"
      fontWeight="semibold"
      marginBottom={1}
      style={{
        "@media screen and (minWidth: 768px)": {
          display: "-webkit-box",
          WebkitLineClamp: "2",
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      }}
      {...props}
    >
      {item?.title}
    </Heading>
  )
}

export default LearnPageTitle
